import type { FC } from "react";
import type { TQuickOption } from "../utils/types";

interface QuickOptionsProps {
  options: TQuickOption[];
  onSelectOption?: (option: TQuickOption) => void;
  isDisabled?: boolean;
}

const QuickOptions: FC<QuickOptionsProps> = ({
  options,
  onSelectOption,
  isDisabled,
}) => (
  <div className="flex flex-wrap gap-2">
    {options.map((option) => (
      <button
        className="hover:bg-green-50 min-h-[38px] rounded-full border border-green bg-white px-4 py-1.5 text-sm font-semibold text-ink-900 transition disabled:cursor-not-allowed disabled:opacity-60"
        disabled={isDisabled}
        key={option.value}
        onClick={() => onSelectOption?.(option)}
        type="button"
      >
        {option.label}
      </button>
    ))}
  </div>
);

export default QuickOptions;
